import { getAppVersion, updateAppVersion } from "_services";
import { ButtonHeading, CommonInput } from "components";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

const ManageAppVersion = () => {
  const obj = {
    minAppVersionRequired: "",
  };
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState(obj);

  useEffect(() => {
    fetchAppVersion();
  }, []);

  const fetchAppVersion = async (data) => {
    try {
      const res = await getAppVersion();
      if (res) {
        setFormValue({
          minAppVersionRequired:
            res?.data?.systemSettings?.minAppVersionRequired,
        });
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }
  };

  const handleOnChange = (name, value) => {
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    setLoading(true);
    const payload = {
      ...formValue,
    };
    try {
      const res = await updateAppVersion(payload);
      if (res) {
        fetchAppVersion();
        setLoading(false);
        toast.success(res?.message);
      } else {
        toast.error(res?.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <ButtonHeading title={"Manage App Version"} />
        <div
          for="appVersion"
          className="pt-2 px-4"
          style={{ color: "black", fontWeight: "500", opacity: "0.8" }}
        >
          Change App Version:
        </div>
        <div class="__broadCastFx ">
          <div style={{ maxWidth: "600px" }}>
            <CommonInput
              type="text"
              placeholder="Enter Version"
              label="Enter Version"
              name="minAppVersionRequired"
              value={formValue?.minAppVersionRequired}
              // focus={!!formError.imageUrl}
              // error={formError.imageUrl}
              onChange={({ target: { name, value } }) =>
                handleOnChange(name, value)
              }
            />
          </div>

          <div>
            <button
              className="_addComm_btn"
              onClick={() => handleUpdate()}
              disabled={loading}
            >
              Update Version
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageAppVersion;
